import axios from "axios";

const getAuthToken = () => "Bearer " + localStorage.getItem("token");

const getHeaders = () => ({
    headers: {
        Authorization: getAuthToken(),
    },
});

// API config
const NOTIFICATIONS_API = axios.create({
    baseURL: "https://api.tvcom.uz",
});

const getAllNotifications = async (page) => {
    let { headers } = getHeaders();

    const config = {
        params: {
            page,
        },
        headers,
    };

    if (!localStorage.getItem("token")) delete config.headers;

    try {
        const { data } = await NOTIFICATIONS_API.get(
            `/api/v1.2.0/notifications`,
            config
        );

        return data.data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

const getAboutNotification = async (id) => {
    let { headers } = getHeaders();

    let params = { headers };

    if (!localStorage.getItem("token")) params = {};

    try {
        const { data } = await NOTIFICATIONS_API.get(
            `/api/v1.2.0/notifications/${id}`,
            params
        );

        return data.data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

const login = async () => {
    let { headers } = getHeaders();

    let params = { headers };

    try {
        const { data } = await NOTIFICATIONS_API.post(
            `/api/v1.0.0/customer/login`,
            {},
            params
        );

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

const logout = async (id) => {
    let { headers } = getHeaders();

    let params = { headers };

    try {
        const { data } = await NOTIFICATIONS_API.post(
            `/api/v1.0.0/customer/logout`,
            {},
            params
        );

        return data;
    } catch (error) {
        console.log(error);
        return error;
    }
};

export default { getAllNotifications, getAboutNotification, login, logout };
